module.exports = __webpack_public_path__ + "img/logo-sanpedroysanpablo.7abca27b.png";